import React, { useState, useRef, useEffect } from "react";
import '../../css/elements.css';
import { useDispatch, useSelector } from 'react-redux';
import Icon from "../../assets/icons/icon";
import { formatTimestamp } from "../../utilities/dashFunction";
import { formatStates } from '../../utilities/genericUtils';

// import { updateScheduledCallInfo } from '../../features/scheduledCallSlice';



function QuilityNestedBlock({ unixTommddyyyy, title, index, data, addToQueue, openLead }) {
    const isFeature983Enabled = process.env.REACT_APP_FUNNEL_FEATURE_983 === 'true'
    const queue = useSelector((state) => state.queue.originalQueue);
    const agentInfo = useSelector((state) => state.agent.userData)
    const [isOpen, setIsOpen] = useState(false);
    const [manipulatedData, setManipulatedData] = useState('');
    const innerWrapperRef = useRef(null);

    const dispatch = useDispatch();

    const handleOptionClick = (option) => {
        setIsOpen(!isOpen);
    };
    const getHeight = () => {
        if (innerWrapperRef.current && innerWrapperRef.current.clientHeight === 0) {
            return 0
        }
        if (innerWrapperRef.current) {
            return innerWrapperRef.current.clientHeight;
        }
        return 0;
    };

    const handleOpenLead = (title, item) => {
        const validBlocks = ['Appointments', 'Scheduled Calls']

        if (validBlocks.includes(title)) {
            openLead(item.lead_id)
        }
    }

    const activityScheduleArray = useSelector((state) => state.scheduledCallInfo);


    useEffect(() => {
        if (data) {
            switch (title) {
                case 'Appointments':
                    const appointmentData = [];

                    // data[index].map((item, index) => (
                    activityScheduleArray?.appointmentsArray?.data?.map((item, index) => (
                        appointmentData.push({
                            'Time': item.apptDate,
                            "Meeting": item.apptTitle,
                            "lead_id": item.apptLead

                        })
                    ))
                    setManipulatedData(appointmentData.sort(_apptSortKey));
                    break;

                case 'Scheduled Calls':
                    const callData = [];
                    // data[index].map((item, index) => (
                    activityScheduleArray?.schedulecallArray?.data.map((item, index) => (
                        callData.push({
                            'Time': item.schedTime,
                            "Name": `${item.schedLeadFirst} ${item.schedLeadLast}`,
                            "lead_id": item.schedLead

                        })
                    ))
                    setManipulatedData(callData);

                    break;

                default:
                    break;
            }
        }
    }, [activityScheduleArray, data])
    return (
        <span className="quilityNestedBlockWrapper" 
            style={{
                overflow: 'hidden',
                height: title === 'Marketplace'
                        ? isOpen
                            ? getHeight() + 45
                            : '45px'
                        : title === 'Activity'
                            ? 'fit-content'
                            : isOpen && getHeight() !== 0
                                ? getHeight() + 90
                                : '45px'
            }} >
            <div className="quilityNestedBlockHeader" onClick={() => handleOptionClick()}>
                <div className="quilityParentBlockTitle ">{title}</div>
                <span className={`quilityBlockIcon ${isOpen ? 'rotate' : ''}`} style={{ marginTop: '-5px', transition: 'all .5s' }}><span className="fontello"><Icon name={'q-up'} size={20} className="closeIcon" adjust="fontello" /></span></span>
            </div>
            <div className="quilityNestedBlockContent" ref={innerWrapperRef} style={{ padding: '0px' }}>
                {manipulatedData && title !== 'Custom Filters' && manipulatedData.map((item, index2) => (
                    <div className="quilityDataLine clickable " style={{ padding: '10px 25px' }} key={`filtersBlocks_${index2}_nested_block`} onClick={() => handleOpenLead(title, item)}>
                        <div className="infoDataBlockWrapper">
                            {Object.keys(item).map(key => (
                                !key.includes("_") && (
                                    <div className="infoDataBlock" key={`infodatablock${key}`}>
                                        <span className="quilityDataLineTitleShort">{key}</span>
                                        <div className="quilityDataLineValue">{key === 'Time' ? formatTimestamp(item[key]) : item[key]}</div>
                                    </div>
                                )
                            ))}
                        </div>
                    </div>
                ))}

                {data && title === 'Custom Filters' && data[index].map((item, index2) => (
                    <div className="quilityDataLine" key={`filtersBlocks${index2}_custom_filters`} style={{ display: 'flex' }}>
                        <span className="quilityDataLineTitle" style={{ display: 'inline-block', flex: '1' }}>{item.name}</span>
                        <span className="quilityDataLineValue" style={{ display: 'inline-block', flex: '1' }}>{item.name}</span>
                        <span className="quilityDataLineValue" style={{ display: 'inline-block', flex: '1' }}>
                            <span className="addToQueueButton" onClick={() => { addToQueue(item.params.includes('WHERE') ? item.params : `WHERE (\`state\`= '${item.params}')`) }}>Add To Queue</span>
                        </span>
                    </div>
                ))}
                {data && title === 'Activity' && (
                    <>

                    </>
                )}
            {data[index] && title === 'Marketplace' && (
              <div className="marketplace_scrolldiv" style={{ maxHeight: '300px', overflowY: 'scroll' }}>
                {data[index] && title === 'Marketplace' && data[index].map((item, index2) => (
                    <div className="quilityDataLine" key={`filtersBlocks${index}_market_place_${index2}`} style={{ display: 'flex', flexDirection: 'column', padding: '1rem'}}>
                     {item.order_id && <div style={{display:'flex'}}>
                        <span className="quilityDataLineTitle" style={{padding: '0.25rem 0', display:'inline-block', minWidth:'150px'}}>Order Id</span>
                        <span className="quilityDataLineValue" style={{padding: '0.25rem 0'}}>{item.order_id}</span>
                        </div> }
                        <div style={{display:'flex'}}>
                        <span className="quilityDataLineTitle" style={{padding: '0.25rem 0', display:'inline-block', minWidth:'150px'}}>Lead Vendor</span>
                        <span className="quilityDataLineValue" style={{padding: '0.25rem 0'}}>{item.vendorName}</span>
                        </div>
                        <div style={{display:'flex'}}>
                        <span className="quilityDataLineTitle" style={{padding: '0.25rem 0', display:'inline-block', minWidth:'150px'}}>Lead Type</span>
                        <span className="quilityDataLineValue" style={{padding: '0.25rem 0'}}>{item.typeName}</span>
                        </div>
                        <div style={{display:'flex'}}>
                        <span className="quilityDataLineTitle" style={{padding: '0.25rem 0', display:'inline-block', minWidth:'150px'}}>Date</span>
                        <span className="quilityDataLineValue" style={{padding: '0.25rem 0'}}>{unixTommddyyyy(item.order_date)}</span>
                        </div>
                        <div style={{display:'flex'}}>
                        <span className="quilityDataLineTitle" style={{ padding: '0.25rem 0', display:'inline-block', minWidth:'150px'}}>Quantity</span>
                        <span className="quilityDataLineValue" style={{ padding: '0.25rem 0'}}>{item.order_size}</span>
                        </div>
                        <div style={{display:'flex'}}>
                        <span className="quilityDataLineTitle" style={{ padding: '0.25rem 0', display:'inline-block', minWidth:'150px'}}>Fulfilled</span>
                        <span className="quilityDataLineValue " style={{ padding: '0.25rem 0' }}>{item.fulfilled}</span>  
                        </div>
                        <div style={{display:'flex'}}>
                        <span className="quilityDataLineTitle" style={{ padding: '0.25rem 0', display:'inline-block', minWidth:'150px'}}>Order Value</span>
                        <span className="quilityDataLineValue " style={{ padding: '0.25rem 0'}}>$ {(item.total_amount / 100)}</span>
                        </div>
                        <div style={{display:'flex'}}>
                        <span className="quilityDataLineTitle" style={{padding:'0.25rem 0', display:'inline-block', minWidth:'150px'}}>Order Type</span>
                        <span className="quilityDataLineValue" style={{padding:'0.25rem 0'}}>{(item.order_type === 'standing' || item.order_type === 'SLO') ? 'SLO' : 'OTLO'}</span>
                        </div>
                        <div style={{display:'flex'}}>
                        <span className="quilityDataLineTitle" style={{padding: '0.25rem 0', display:'inline-block', minWidth:'150px'}}>States</span>
                        <span className="quilityDataLineValue" style={{padding: '0.25rem 0'}}>{formatStates(item.states)}</span>
                        </div>   
                        {item.lead_level && <div style={{display:'flex'}}>
                        <span className="quilityDataLineTitle" style={{padding: '0.25rem 0', display:'inline-block', minWidth:'150px'}}>Lead Level</span>
                        <span className="quilityDataLineValue" style={{padding: '0.25rem 0'}}>{item.lead_level}</span>
                        </div>} 
                        {(item.lead_order_status || item.status) && <div style={{display:'flex'}}>
                        <span className="quilityDataLineTitle" style={{padding: '0.25rem 0', display:'inline-block', minWidth:'150px'}}>Lead Order Status</span>
                        <span className="quilityDataLineValue" style={{padding: '0.25rem 0'}}>{item.lead_order_status ? item.lead_order_status : item.status }</span>
                        </div> } 
                    </div>
                  ))}
                </div>
)}
            </div>
        </span>
    );
}

export default QuilityNestedBlock;

const coll = new Intl.Collator(
	undefined,
	{
		numeric: true,
		usage: "sort",
	},
);
const cmp = coll.compare;

function _apptSortKey(a, b) {
	return cmp(a.Time, b.Time);
}
/*<div className="timeOptions">
                            <span className="timeTitle">Work Week</span>
                            <ToggleSwitch isToggled={isToggled} handleToggle={handleToggle}/>
                            <span className="timeTitle">This Month</span>
                        </div>
                        <div className="quilityDataLine" key={`filtersBlocks${index}1`} style={{display: 'flex'}}>
                            <span className="quilityDataLineTitle" style={{display: 'inline-block',flex: '1'}}>Dials</span>
                            <span className="quilityDataLineValue" style={{display: 'inline-block',flex: '1'}}>
                                {data[2][0].totalDials !== null ? data[2][0].totalDials : 0}
                            </span>
                        </div>
                        <div className="quilityDataLine" key={`filtersBlocks${index}2`} style={{display: 'flex'}}>
                            <span className="quilityDataLineTitle" style={{display: 'inline-block',flex: '1'}}>Contacts</span>
                            <span className="quilityDataLineValue" style={{display: 'inline-block',flex: '1'}}>
                                {data[2][0].total_contact !== null ? data[2][0].total_contact : 0}
                            </span>
                        </div>
                        <div className="quilityDataLine" key={`filtersBlocks${index}3`} style={{display: 'flex'}}>
                            <span className="quilityDataLineTitle" style={{display: 'inline-block',flex: '1'}}>Appointments</span>
                            <span className="quilityDataLineValue" style={{display: 'inline-block',flex: '1'}}>
                                {data[2][0].total_appointment !== null ? data[2][0].total_appointment : 0}
                            </span>
                        </div>
                        <div className="quilityDataLine" key={`filtersBlocks${index}4`} style={{display: 'flex'}}>
                            <span className="quilityDataLineTitle" style={{display: 'inline-block',flex: '1'}}>Applications</span>
                            <span className="quilityDataLineValue" style={{display: 'inline-block',flex: '1'}}>
                                {data[2][0].total_application !== null ? data[2][0].total_application : 0}
                            </span>
                        </div>
                        <div className="quilityDataLine" key={`filtersBlocks${index}5`} style={{display: 'flex'}}>
                            <span className="quilityDataLineTitle" style={{display: 'inline-block',flex: '1'}}>Talk Time</span>
                            <span className="quilityDataLineValue" style={{display: 'inline-block',flex: '1'}}>
                                {data[2][0].talkTime !== null ? Math.round(data[2][0].talkTime / 60) : 0} Minutes
                            </span>
                        </div>*/